import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationBoxItemMinutes from "../../components/DeclarationBoxItemMinutes";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import Nieruchomosci from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-1_pl.mdx";
import DeclarationBoxIndividual from "../../components/DeclarationBoxIndividual";
import BackgroundSection from "../../components/BackgroundSection";
import SectionBox from "../../components/SectionBox";
import CustomListWithZero from "../../components/CustomListWithZero";
import FAQ from "../../components/FAQ";

import PlikDek1 from "../../content/przyjaznedeklaracje/plik-dek/section-1_pl.mdx";
import PlikDek2 from "../../content/przyjaznedeklaracje/plik-dek/section-2_pl.mdx";
import PlikDek3 from "../../content/przyjaznedeklaracje/plik-dek/section-3_pl.mdx";
import PlikDek4 from "../../content/przyjaznedeklaracje/plik-dek/section-4_pl.mdx";
import PlikDek5 from "../../content/przyjaznedeklaracje/plik-dek/section-5_pl.mdx";
import PlikDek6 from "../../content/przyjaznedeklaracje/plik-dek/section-6_pl.mdx";
import PlikDek7 from "../../content/przyjaznedeklaracje/plik-dek/section-7_pl.mdx";
import PlikDek8 from "../../content/przyjaznedeklaracje/plik-dek/section-8_pl.mdx";

/* CUSTOM LIST WITH ZERO */
import CustomList1 from "../../content/przyjaznedeklaracje/plik-dek/custom-list-with-zero/list-1_pl.mdx";
import CustomList2 from "../../content/przyjaznedeklaracje/plik-dek/custom-list-with-zero/list-2_pl.mdx";
import CustomList3 from "../../content/przyjaznedeklaracje/plik-dek/custom-list-with-zero/list-3_pl.mdx";
import CustomList4 from "../../content/przyjaznedeklaracje/plik-dek/custom-list-with-zero/list-4_pl.mdx";

export default function PlikDek(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "plikdek";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<PlikDek1 />
			</Section>

			<Section mdx lighterdark noPanel>
				<PlikDek2 />
			</Section>

			<Section mdx>
				<PlikDek3 />
			</Section>

			<Section mdx lighterdark>
				<PlikDek4 />
			</Section>

			<Section mdx>
				<PlikDek5 />
			</Section>

			{/* <Section mdx lighterdark>
        <PlikDek6 />
      </Section> */}

			<Section mdx lighterdark>
				<PlikDek7 />

				<ol className="custom-list-with-zero mdx">
					<li>
						<div className="custom-list-with-zero__content">
							<CustomList1 />
						</div>
					</li>
					<li>
						<div className="custom-list-with-zero__content">
							<CustomList2 />
						</div>
					</li>
					<li>
						<div className="custom-list-with-zero__content">
							<CustomList3 />
						</div>
					</li>
					<li>
						<div className="custom-list-with-zero__content">
							<CustomList4 />
						</div>
					</li>
				</ol>
			</Section>

			<Section mdx>
				<PlikDek8 />
			</Section>

			<Section
				id="kalkulatory-podatkow-i-oplat-w-ktorych-mozesz-wykorzystac-plik-dek"
				title="sections.kalkulatoryplikdek.title"
				titleLeft
				lighterdark
			>
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
							/>
						);
					})}
					<DeclarationBoxItemMinutes />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} context={Podatek} />
			</Section>
		</SectionLayout>
	);
}
